module.exports = __webpack_public_path__ + "static/media/shuziyuanli.4bad12f7.png";